import CardTeamSettingsName from "@/components/team/card-team-setting-name";
import { TeamSettingCompanyLinked } from "@/components/team/team-setting-company-linked";
import {
  TeamSettingInstruction,
  type TeamSettingInstructionHandle,
} from "@/components/team/team-setting-instruction";
import { TeamSettingLLMPermissions } from "@/components/team/team-setting-llm-permissions";
import { TeamSettingPinnedPromptsDefault } from "@/components/team/team-setting-pinned-prompts-default";
import { useRef } from "react";

export default function TeamSettingsPage() {
  const instructionRef = useRef<TeamSettingInstructionHandle>(null);

  return (
    <>
      <CardTeamSettingsName />
      <TeamSettingCompanyLinked
        onCompanyChanged={() => instructionRef.current?.refetch()}
      />
      <TeamSettingLLMPermissions />
      <TeamSettingInstruction ref={instructionRef} />
      <TeamSettingPinnedPromptsDefault />
    </>
  );
}
